import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
// import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg";
import Leanda from "images/latest/IMG_6775.webp"
import Baby from "images/latest/baby.jpeg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

 
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 relative flex flex-col`;

// const Image = styled.div(props => [
//   `background-image: url("${props.imageSrc}");`,
//   tw`rounded-full bg-no-repeat bg-center h-32 w-32 md:h-full md:w-full`,
//   `background-size: 120%;`,
//   `background-position: center;`,
//   `border-radius: 50%;`,
//   `@media (max-width: 767px) {
//     border-radius: 50%; /* Ensure it remains a circle */
//     height: 280px; /* Increase the height */
//     width: 280px; /* Increase the width */
//   }`
// ]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-80 md:h-auto md:flex-1`
]);

const SecondaryImageRow = tw.div`flex flex-col items-center mt-8`;
const SecondaryImage = tw.img`w-24 h-24 md:w-32 md:h-32 rounded-full object-cover flex-shrink-0`;
const SecondaryImageText = tw.p`mt-4 text-center text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-3xl lg:text-4xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

// const Statistics = tw.div`flex flex-col items-center sm:block text-center md:text-left mt-4`;
// const Statistic = tw.div`text-left sm:inline-block sm:mr-12 last:mr-0 mt-4`;
// const Value = tw.div`font-bold text-lg sm:text-xl lg:text-2xl text-secondary-500 tracking-wide`;
// const Key = tw.div`font-medium text-primary-700`;

// const PrimaryButton = tw(PrimaryButtonBase)`mt-8 md:mt-10 text-sm inline-block mx-auto md:mx-0`;

const DecoratorBlob = styled(SvgDotPattern)(props => [
  tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`
]);

export default ({
  subheading = " ",
  heading = (
    <>
    <span tw="text-primary-500">Wie</span> ben ik?
    </>
  ),
   description = (
  <>

Mijn naam is Leanda Bekendam-Bosschaart (BB). Ervaren GZ-psycholoog, neuropsycholoog, diagnosticus, en per 2024 praktijkhouder. In mijn werk sta ik voor doen wat bewezen is met oog voor het individu. Duidelijkheid, transparantie, en samen beslissen zijn voor mij belangrijk. Ik kom oorspronkelijk uit Rotterdam, en ben met de komst van onze dochter in 2023 verhuisd naar het groene Wageningen. In mijn vrije tijd ga ik er graag op uit met mijn gezin, eet een hapje met vrienden, lees een boek of game ik.     <br />
    <br />
    Waarom vertel ik je dit? Omdat een goede klik (behandelrelatie) sterk bijdraagt aan betere behandeluitkomsten, zoals het verminderen van jouw klachten. De behandelrelatie en een ontspannen sfeer staan bij mij dan ook centraal.    <br />
    
    Wil je meer weten over mijn werkervaring? Kijk gerust op mijn LinkedIn
    <a href="https://www.linkedin.com/in/leanda-bosschaart/" target="_blank" rel="noopener noreferrer">
      <div style={{ 
        display: 'inline-flex', 
        backgroundColor: '#0077b5', 
        borderRadius: '50%', 
        padding: '10px', 
        color: 'white', 
        alignItems: 'center', 
        justifyContent: 'center', 
        marginLeft: '10px'
      }}>
        <FontAwesomeIcon icon={faLinkedinIn} size="1x" />
      </div>
    </a>
     <br />
      <br />
    Van 2 november tot en met 14 maart is een masterstagiaire (psycholoog in opleiding) in de praktijk aanwezig.
  </>
),
  primaryButtonText = "Leer mij kennen",
  primaryButtonUrl = "/about",
  imageSrc = Leanda,
  secondaryImageSrc = Baby,
  secondaryImageText = "Na de geboorte van mijn tweede dochter is de praktijk per 2 november 2026 weer geopend!",
  imageCss = null,
  imageContainerCss = null,
  imageDecoratorBlob = false,
  imageDecoratorBlobCss = null,
  imageInsideDiv = true,
  statistics = null,
  textOnLeft = false
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  //Change the statistics variable as you like, add or delete objects
  const defaultStatistics = [
    {
      key: "Clients",
      value: "2282+"
    },
    {
      key: "Projects",
      value: "3891+"
    },
    {
      key: "Awards",
      value: "1000+"
    }
  ];

  if (!statistics) statistics = defaultStatistics;

  return (
    <Container>
      <TwoColumn css={!imageInsideDiv && tw`md:items-center`}>
        <ImageColumn css={imageContainerCss}>
          {imageInsideDiv ? <Image imageSrc={imageSrc} css={imageCss} alt="Psycholoog wageningen" /> : <img src={imageSrc} css={imageCss} alt="Psycholoog wageningen" />}
          {imageDecoratorBlob && <DecoratorBlob css={imageDecoratorBlobCss} />}
          {secondaryImageSrc && (
            <SecondaryImageRow>
              <SecondaryImage src={secondaryImageSrc} alt="Baby" />
              <SecondaryImageText>{secondaryImageText}</SecondaryImageText>
            </SecondaryImageRow>
          )}
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            <Description>{description}</Description>
            {/*<Statistics>*/}
            {/*  {statistics.map((statistic, index) => (*/}
            {/*    <Statistic key={index}>*/}
            {/*      <Value>{statistic.value}</Value>*/}
            {/*      <Key>{statistic.key}</Key>*/}
            {/*    </Statistic>*/}
            {/*  ))}*/}
            {/*</Statistics>*/}
            {/* <PrimaryButton as="a" href={primaryButtonUrl}>
              {primaryButtonText}
            </PrimaryButton> */}
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
